// @flow

import * as React from 'react'
import { colors } from '@toggl/style'

type IconProps = {
  color?: string,
}

export const Github = ({ color }: IconProps) => (
  <svg viewBox="0 0 16 16" version="1.1" fill={color || colors.beige}>
    <g id="Symbols" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g
        id="Footer-product"
        transform="translate(-835.000000, -520.000000)"
        fillRule="nonzero"
      >
        <g id="subbar" transform="translate(0.000000, 501.000000)">
          <g id="Group-30" transform="translate(588.000000, 18.000000)">
            <g id="logo" transform="translate(247.000000, 1.000000)">
              <path
                d="M8,0.0216802168 C3.58,0.0216802168 0,3.68476965 0,8.20257995 C0,11.8177995 2.292,14.8835556 5.47,15.9644444 C5.87,16.0414526 6.01666667,15.7882276 6.01666667,15.5710786 C6.01666667,15.3768238 6.01,14.8620488 6.00666667,14.1800759 C3.78133333,14.6733442 3.312,13.0825366 3.312,13.0825366 C2.948,12.1383198 2.422,11.8857886 2.422,11.8857886 C1.69733333,11.378645 2.478,11.3890515 2.478,11.3890515 C3.28133333,11.4459404 3.70333333,12.2319783 3.70333333,12.2319783 C4.41666667,13.4828401 5.576,13.1213875 6.03333333,12.9125637 C6.10533333,12.3832195 6.31133333,12.0231545 6.54,11.8184932 C4.76333333,11.613832 2.896,10.9103523 2.896,7.77591328 C2.896,6.88303523 3.206,6.15319241 3.71933333,5.58083469 C3.62933333,5.37409214 3.35933333,4.54226558 3.78933333,3.41558808 C3.78933333,3.41558808 4.45933333,3.19635772 5.98933333,4.2543523 C6.62933333,4.07258537 7.30933333,3.98239566 7.98933333,3.97823306 C8.66933333,3.98239566 9.34933333,4.07258537 9.98933333,4.2543523 C11.5093333,3.19635772 12.1793333,3.41558808 12.1793333,3.41558808 C12.6093333,4.54226558 12.3393333,5.37409214 12.2593333,5.58083469 C12.7693333,6.15319241 13.0793333,6.88303523 13.0793333,7.77591328 C13.0793333,10.9186775 11.2093333,11.6103631 9.42933333,11.8115556 C9.70933333,12.0571491 9.96933333,12.5587425 9.96933333,13.325355 C9.96933333,14.4201192 9.95933333,15.2998157 9.95933333,15.5655285 C9.95933333,15.7799024 10.0993333,16.0359024 10.5093333,15.9540379 C13.71,14.8800867 16,11.8122493 16,8.20257995 C16,3.68476965 12.418,0.0216802168 8,0.0216802168 L8,0.0216802168 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
